import * as React from "react";

export default () => {
  return <div>Ange hur signeringsstatusen för avtalet ser ut.</div>;
};
